module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiB2aWV3Qm94PSIwIDAgMjQgMjQiPjxwYXRoIGZpbGw9IiNmZmZmZmYiIGQ9Ik0xMSAxN2gydi02aC0yem0xLThxLjQyNSAwIC43MTMtLjI4OFQxMyA4dC0uMjg4LS43MTJUMTIgN3QtLjcxMi4yODhUMTEgOHQuMjg4LjcxM1QxMiA5bTAgMTNxLTIuMDc1IDAtMy45LS43ODh0LTMuMTc1LTIuMTM3VDIuNzg4IDE1LjlUMiAxMnQuNzg4LTMuOXQyLjEzNy0zLjE3NVQ4LjEgMi43ODhUMTIgMnQzLjkuNzg4dDMuMTc1IDIuMTM3VDIxLjIxMyA4LjFUMjIgMTJ0LS43ODggMy45dC0yLjEzNyAzLjE3NXQtMy4xNzUgMi4xMzhUMTIgMjIiLz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-info1.svg
// module id = vlIi
// module chunks = 1